<div class="flex flex-col gap-[0.94rem]  h-[calc(100vh-100px)]">
  <div
    class="grid grid-cols-2 justify-between gap-4 md:grid md:justify-between"
  >
    <h2
      class="translate-y-[4px] text-nowrap text-2xl font-extrabold leading-[1.3125rem] text-mango-black17"
    >
      Roles
    </h2>

    <button
      *appHasPermission="'create_roles'"
      type="button"
      mango-button
      routerLink="/admin/roles/add-role"
      class="w-fit justify-self-end"
    >
      + Add New Role
    </button>
  </div>

  <!-- Search Input and Filters -->
  <app-filters
  [filters]="filterStructure"
  ></app-filters>

  <!-- table skeleton loader -->
   @if ((isFetchingRolesList$ | async) || (isFetchingPermissions$ | async)) {
    <div class="mt-[0.94rem]">
      <app-table-skeleton-loader></app-table-skeleton-loader>
    </div>
  }

  @if (!(isFetchingRolesList$ | async)) {
  <div
    *appHasPermission="'get_roles'"
    class="rounded-lg border border-solid border-mango-gray200 flex-1 overflow-y-auto bg-white">
  
    <div class="inline-block min-w-full align-middle">
      <div
        class=" shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg w-full  max-h-[calc(100vh-100px)"
      >
        <table class="min-w-full divide-y divide-gray-300">
          <thead class="bg-gray-50 sticky top-0 z-20">
            <tr>
              <th
                scope="col"
                class="sticky top-0 left-0 z-30 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 bg-gray-50 border-r border-gray-300"
              >
                Permissions
              </th>
              @for (role of rolesList$ | async; track role.id){
              <th
                scope="col"
                class=" sticky top-0 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 whitespace-nowrap"
              >
              <div class="flex items-center gap-2">
                <span>{{role.name | titlecase}}</span>
                <div class="cursor-pointer">
                  <app-dropdown
                    [id]="role.id"
                    [actionList]="roleDropdownActions(role)"
                  ></app-dropdown>
                </div>
              </div>
              </th>
            }
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">
            @for (group of filteredGroupKeys; track group) {
              <tr>
                <td 
              
                  class="sticky left-0 z-10 whitespace-nowrap bg-white px-4 py-4 font-semibold text-sm sm:pl-4  text-gray-900 border-r border-gray-300 cursor-pointer "
                  (click)="permissionGroupState[group] = !permissionGroupState[group]"
                >
                  <div class="flex items-center gap-2">
                    <!-- chevron down or up icon -->
                    <img
                    [ngClass]="{
                      'rotate-180': permissionGroupState[group],
                    }"
                    class="dropdown--toggle-icon rotate-180"
                    src="assets/images/svgs/chevron-down-arrow.svg"
                    alt=""
                  />
                    <span class="capitalize">{{ group }}</span>

                  
                  </div>
                </td>
              </tr>

              <ng-container *ngIf="permissionGroupState[group]">
                @for (permission of filteredGroupedPermissions[group]; track permission) {
                  <tr>
                    <td
                      class="sticky left-0 z-10 bg-white whitespace-nowrap py-4 pl-6 pr-4 text-sm font-medium text-gray-900 sm:pl-10 border-r border-gray-300"
                    >
                      {{ permission.name }}
                    </td>
                    @for (role of rolesList$ | async; track $index) {
                      <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6">
                        <input
                          class="accent-gray-900 border-gray-300 text-black focus:ring-black"
                          type="checkbox"
                          [checked]="hasPermission(role, permission)"
                          (change)="togglePermission(role, permission)"
                        />
                      </td>
                    }
                  </tr>
                }
              </ng-container>
            }
          </tbody>
        </table>
        <div
          *ngIf="(filteredGroupKeys.length === 0 && searchKeyword) || (totalCount === 0 && !isLoading)"
          class="flex w-full px-6 pb-6 pt-6"
        >
          {{ filteredGroupKeys.length === 0 && searchKeyword 
              ? 'No permissions match "' + searchKeyword + '"' 
              : 'No roles found.' }}
        </div>

        <div *ngIf="isLoading === true" class="flex w-full px-6 pb-6 pt-6">
          ...Fetching roles. Please wait.
        </div>

        <app-table-navigator
          *ngIf="totalCount"
          [total]="totalCount"
          (onNavigation)="navigate($event)"
        >
        </app-table-navigator>
      </div>
    </div>
 
</div>
  }

</div>

<router-outlet></router-outlet>
